import { Reveal } from "@components/ui";

const gasisFollows = [
  "UAE Fire & Life Safety Code of Practice 2021",
  "Dubai Civil Defense (DCD) LPG/SNG regulations",
  "ESMA Gas Safety Standards",
  "ISO 45001 — Occupational Health & Safety",
];

const technicianCerts = [
  { label: "DCD-certified", tag: "Certification" },
  { label: "ESMA-approved", tag: "Approval" },
  {
    label: "Trained for confined space & hazardous gas operations",
    tag: "Training",
  },
];

export function ComplianceSection() {
  return (
    <section className="w-full bg-[#f5f5f7] overflow-hidden px-5 md:px-10 lg:px-[180px] py-12 md:py-16 lg:py-[100px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col items-center gap-10 md:gap-14 lg:gap-16">
        {/* Title */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-4 max-w-[1112px] mx-auto text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase">
              Compliance
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1]">
              Civil Defense & ESMA Compliance
            </h2>
            <p className="text-[14px] md:text-base lg:text-[22px] tracking-[-0.04em] text-[#62636c] max-w-[800px]">
              GASIS maintains the highest standards of safety compliance and
              certification.
            </p>
          </div>
        </Reveal>

        {/* Cards */}
        <Reveal direction="up" className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {/* GASIS Follows Card */}
            <div className="rounded-[20px] bg-white p-6 md:p-8 lg:p-10 flex flex-col gap-6 hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)] transition-shadow duration-300">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-[14px] bg-[#122d63] flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                    <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z" stroke="white" strokeWidth="1.5" />
                  </svg>
                </div>
                <h3 className="text-[20px] md:text-[24px] lg:text-[28px] font-semibold tracking-[-0.04em] text-[#122d63]">
                  GASIS Follows
                </h3>
              </div>
              <div className="flex flex-col gap-3">
                {gasisFollows.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 p-3 md:p-3.5 rounded-[12px] bg-[#f8f9fb]"
                  >
                    <div className="w-5 h-5 rounded-full bg-[#122d63]/10 flex items-center justify-center shrink-0 mt-0.5">
                      <svg viewBox="0 0 12 12" className="w-3 h-3">
                        <path d="M10 3L4.5 8.5 2 6" stroke="#122d63" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <p className="text-[13px] md:text-[16px] lg:text-[18px] tracking-[-0.03em] text-[#4a4b52] leading-[1.5]">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Technicians Card */}
            <div className="rounded-[20px] bg-gradient-to-br from-[#122d63] to-[#1a3f7a] p-6 md:p-8 lg:p-10 flex flex-col gap-6 hover:shadow-[0_8px_32px_rgba(18,45,99,0.3)] transition-shadow duration-300">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-[14px] bg-white/15 flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                    <path d="M16 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                    <circle cx="10" cy="7" r="4" stroke="white" strokeWidth="1.5" />
                    <path d="M20 8v6M23 11h-6" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </div>
                <h3 className="text-[20px] md:text-[24px] lg:text-[28px] font-semibold tracking-[-0.04em] text-white">
                  All Technicians Are
                </h3>
              </div>
              <div className="flex flex-col gap-3">
                {technicianCerts.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 p-3.5 md:p-4 rounded-[12px] bg-white/8"
                  >
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center shrink-0 mt-0.5">
                      <svg viewBox="0 0 12 12" className="w-3 h-3">
                        <path d="M10 3L4.5 8.5 2 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="flex flex-col gap-1">
                      <p className="text-[14px] md:text-[17px] lg:text-[19px] tracking-[-0.03em] text-white leading-[1.4]">
                        {item.label}
                      </p>
                      <span className="text-[11px] md:text-[12px] font-medium uppercase tracking-[0.05em] text-white/40">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
